import { SupplierVoucherWebService } from '@linktivity/gds-neo';
import config from '../config';

const supplierVoucherApi = new SupplierVoucherWebService.VoucherApi(config);

export default supplierVoucherApi;
